import { ROUTE } from 'constant';
import React from 'react';
import Shared from 'screens/shared';
import { createLink } from 'utils';
import Tiles from './tiles';

export const MonitoringList = ({ history }) => (
  <Shared.widgets.Page route={ROUTE.DASHBOARD.MONITORING} isStrap={false}>
    <Tiles />
    <hr />
    <Shared.components.OverallServers
      title="Select a Server to monitor"
      onItemClick={({ id, dataCenter }) => {
        history.push(createLink(ROUTE.DASHBOARD.MONITORING_SERVER, { dcId: dataCenter?.id, serverId: id }));
      }}
    />
  </Shared.widgets.Page>
);
